import { useSpring, animated } from 'react-spring';
import './Style/Style.css'

const AnimateClose = () => {
    const animationProps = useSpring({
        from: { width: 20 }, 
        to: { width : 174.680462 }, 
        config: { duration: 2000}, 
      })

        return (
    <div>
    <svg id="ejCv4LRewBg1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300" shape-rendering="geometricPrecision" text-rendering="geometricPrecision">
        <animated.rect width={animationProps.width} height="37.127206" rx="18.56" ry="18.56" transform="matrix(.707107-.707107 0.707107 0.707107 75.114681 198.63242)" fill="#d9bbf9" stroke-width="0"/>
        <animated.rect width={animationProps.width} height="37.127206" rx="18.56" ry="18.56" transform="matrix(.707107 0.707107-.707107 0.707107 101.36758 75.114681)" fill="#d9bbf9" stroke-width="0"/>
    </svg>
    </div>

        );
      };


export default AnimateClose;